import { z } from "zod";
import { DateTypeSchema, TemplateTypeSchema } from "./core.schema";
import { BaseFirestoreWStatusTagsSchema } from "./firestore.schema";
import { AgendaItemSchema, PublicAgendaItemSchema } from "./agendaItem.schema";

// Schemas

export const AgendaModuleSchema = BaseFirestoreWStatusTagsSchema.merge(
  TemplateTypeSchema
).extend({
  name: z.string(),
  description: z.string(),
  body: z.string(),
  type: z.string(),
  agendaItemIds: z.string().array(),
  parentIds: z.string().array().optional(),
  agendaItems: AgendaItemSchema.array().nullable(),
  teamId: z.string().optional(),
  publishedAt: DateTypeSchema.optional(),
});

export const PublicAgendaModuleSchema = AgendaModuleSchema.pick({
  _version: true,
  id: true,
  createdAt: true,
  createdBy: true,
  updatedAt: true,
  updatedBy: true,
  name: true,
  description: true,
  body: true,
  type: true,
  agendaItemIds: true,
  agendaItems: true,
  teamId: true,
  publishedAt: true,
}).extend({
  agendaItems: PublicAgendaItemSchema.array().nullable(),
});

// DTOs

export const CreateAgendaModuleDtoSchema = AgendaModuleSchema.partial();

export const PutAgendaModuleDtoSchema = CreateAgendaModuleDtoSchema;

export const PatchAgendaModuleDtoSchema = CreateAgendaModuleDtoSchema;
